module.exports = __webpack_public_path__ + "assets/no-connection.svg";